import React from "react";

import { observer } from "mobx-react-lite";
import { IconCheckedLight, skinVars } from "@telefonica/mistica";
import { strings } from "../../../localization";
import { useLocation } from "react-router-dom";
import Feedback from "../../../components/templates/Feedback";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useAnalytics, useNavigateCustom } from "../../../hooks";
import { DocumentosCopyBiometryAnalysisStatus, ReasonsCode } from "../../../enum";

interface RouteRegisterSuccessProps {
	isCreated: boolean;
}

const RegisterSuccess: React.FC = observer(() => {
	const { fintechRegisterStore, fraudAnalysisStore } = useGlobalStore();
	const navigate = useNavigateCustom();
	const state = useLocation().state as RouteRegisterSuccessProps;
	const { anticipateMyFGTS } = strings.components.buttons;
	const { anticipation } = strings.pages.navigation;
	const { title, description } = strings.pages.registerSuccess;
	const { updatePageView, addAnalyticEvent } = useAnalytics();

	const onNavigate = async (): Promise<void> => {
		addAnalyticEvent({
			component: "button",
			action: "click.button",
			step: "fgts:cadastro:sucesso",
			description: "antecipar-fgts",
			event: "interaction",
		}, { applySanitize: true });

		// validar fraudAnalysis e redirecionar
		await fraudAnalysisStore.getFraudAnalysis();

		if (fraudAnalysisStore.statusDocumentosCopy === DocumentosCopyBiometryAnalysisStatus.RESEND_NEEDED) {
			if (fraudAnalysisStore.statusReason === ReasonsCode.DOCUMENT_ERROR) {
				return navigate("/error-old-document", { replace: true });
			} else {
				return navigate("/underage-costumer", { replace: true });
			}
		}

		if (fraudAnalysisStore.statusDocumentosCopy === DocumentosCopyBiometryAnalysisStatus.DISAPPROVED) {
			return navigate("/fintech-registration/validate-documents/refused", { replace: true });
		}

		navigate("/fintech-registration/validate-documents/home", { replace: true, state: { statusDocumentosCopy: fraudAnalysisStore.statusDocumentosCopy } });
	};

	const handleUpdateDataFullRegistration = async (): Promise<void> => {
		try {
			await fintechRegisterStore.getPersonalFetch.fetch();
		} catch (error) {
			window.console.error(error);
		}
	};

	const handleAlreadyRegistered = async (): Promise<void> => {
		try {
			await fintechRegisterStore.fetchAlreadyRegistered();

			handleUpdateDataFullRegistration();
		} catch (error) {
			window.console.error(error);
		}

	};

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro FGTS Sucesso",
			pagePath: "/cadastro-fgts/sucesso",
		});

		handleAlreadyRegistered();
	}, []);

	return (
		<Feedback
			heroDataInfoProps={{
				title: title(state.isCreated),
				description,
				icon: <IconCheckedLight size={64} color={skinVars.colors.success} />,
			}}
			buttonProps={{
				onAction: onNavigate,
				textButton: anticipateMyFGTS,
				testID: "button-success-fintech-registration",
			}}
			screenResponsiveProps={{
				navigationTitle: anticipation,
				onBack: () => {
					onNavigate();
				},
			}}
		/>
	);
});

export default RegisterSuccess;
